import UtilisateurTemplate from "./UtilisateurTemplate";

export default function Utilisateur() {
  return <UtilisateurTemplate>Utilisateur</UtilisateurTemplate>;
}

